import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/me/organisations/users/{id}/invite").POST();

export async function resendActivationLink(id: string): Promise<boolean | null> {
    const call = createCall(endpoint, (request) => fetch(withAccountOrNetworkAuthHeaders(request)));

    try {
        await call({ params: { id } });
        return true;
    } catch {
        // Spellbook handles the toast and auth redirect; keep this direct caller quiet.
        return null;
    }
}
